import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useState } from 'react';
// Create context with a generic parameter
var ConfigContext = createContext(null);
// Make the component generic
function ConfigProvider(_a) {
    var children = _a.children, config = _a.config;
    var _b = useState(false), isFilterCollapsed = _b[0], setIsFilterCollapsed = _b[1];
    return (_jsx(ConfigContext.Provider, { value: { config: config !== null && config !== void 0 ? config : {}, isFilterCollapsed: isFilterCollapsed, setIsFilterCollapsed: setIsFilterCollapsed }, children: children }));
}
// Update the hook to be generic
function useConfigContext() {
    var context = React.useContext(ConfigContext);
    if (!context) {
        throw new Error('useConfigContext must be used within ConfigProvider');
    }
    return context;
}
export { ConfigProvider, useConfigContext };
